/**
 * The AlphaRoom mark, used exactly as supplied.
 *
 * The file is swapped by theme rather than recoloured — no CSS filter is ever
 * applied to the mark, and it is never redrawn in code.
 */
import lockupDark from "@/assets/logo/alpharoom-lockup-on-dark.svg";
import lockupLight from "@/assets/logo/alpharoom-lockup.svg";
import markDark from "@/assets/logo/alpharoom-mark-on-dark.svg";
import markLight from "@/assets/logo/alpharoom-mark.svg";
import { useSession } from "@/lib/session";

export function Lockup({ height = 28 }: { height?: number }) {
  const { resolvedTheme } = useSession();
  return (
    <img
      src={resolvedTheme === "dark" ? lockupDark : lockupLight}
      alt="AlphaRoom"
      height={height}
      style={{ height, width: "auto", display: "block" }}
    />
  );
}

export function Mark({ height = 28, onDark = false }: { height?: number; onDark?: boolean }) {
  return (
    <img
      src={onDark ? markDark : markLight}
      alt=""
      height={height}
      style={{ height, width: height, display: "block" }}
    />
  );
}

/** The endorsement line. The parent logo is never merged with the product mark. */
export function Endorsement() {
  return (
    <p className="t-caption ink-tertiary" style={{ letterSpacing: "0.02em" }}>
      an alphabeta product
    </p>
  );
}
